import { make } from "vuex-pathify";
import { getAPI } from "@/store/restAPI.js"; // eslint-disable-line no-unused-varss

// initial state
const state = {
  loadingThreshold: false,
  thresholdResult: [],
  loadingSnapshot: false,
  snapshotResult: null,
};

// getters
const getters = {};

// actions
const actions = {
  retrieveStockSnapshot({commit}, fieldSiteId) {
    commit("SET_LOADING_SNAPSHOT", true);
    return getAPI("dashboard/retrieveStockSnapshot/" + fieldSiteId).then((res) => {
      return res;
    })
      .finally(() => commit("SET_LOADING_SNAPSHOT", false));
  },


  generateLookerEmbedUrl({commit}, userName) {
    commit("SET_LOADING_SNAPSHOT", true);
    return getAPI("dashboard/generateLookerEmbedUrl/" + userName).then((res) => {
      return res;
    })
      .finally(() => commit("SET_LOADING_SNAPSHOT", false));
  },

  generateLookerEmbedUrlLargeProduction({commit}, userName) {
    commit("SET_LOADING_SNAPSHOT", true);
    return getAPI("dashboard/generateLookerEmbedUrlLargeProduction/" + userName).then((res) => {
      return res;
    })
      .finally(() => commit("SET_LOADING_SNAPSHOT", false));
  },


};

// mutations
const mutations = {
  ...make.mutations(state)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};